import { configureStore } from "@reduxjs/toolkit";
import merchantReducer from "../features/merchant/merchantSlice";
import inquiryReducer from "../features/merchant/inquirySlice";
import dashboardReducer from "../features/merchant/dashboardSlice";
import subscriptionReducer from "../features/user/subscriptionSlice";
import suppportReduces from "../features/user/supportSlice";
import cmsReducer from "../features/user/cmsSlice";
import eVisitingCardReducer from "../features/eVisitingCard/VisitingCard.slice";
import merchantListingReducer from "../features/home/merchantListingSlice";
import bannerRequestReducer from "../features/user/bannerRequestSlice";
import sponsorshipReducer from "../features/profileSponsorship/sponsorshipSlice";
import masterReducer from "../features/master/masterSlice";
import bookletReducer from "../features/booklet/bookletSlice";
import merchantSearchReducer from "../features/home/merchantSearchSlice";
import advertisementReducer from "../features/advertisement/advertisementSlice";
import advtCardReducer from "../features/advertisement/advtCardSlice";
import paymentReducer from "../features/payment/paymentSlice";
import ratingReducer from "../features/rating/ratingSlice";
import paymentHistoryReducer from "../features/PaymentHistory/paymentHistorySlice";
import bookingReducer from "../features/bookings/bookingSlice";
import notificationReducer from "../features/notifications/notificationSlice";



export const store = configureStore({
  reducer: {
    merchant: merchantReducer,
    inquiry: inquiryReducer,
    dashboard: dashboardReducer,
    subscription: subscriptionReducer,
    support: suppportReduces,
    cms: cmsReducer,
    eCard: eVisitingCardReducer,
    merchantListing: merchantListingReducer,
    bannerRequest: bannerRequestReducer,
    sponsorship: sponsorshipReducer,
    master: masterReducer,
    booklet: bookletReducer, 
    merchantSearch: merchantSearchReducer,
    advertisement: advertisementReducer,
    advtCard: advtCardReducer,   
    payment: paymentReducer,
    rating: ratingReducer,
    paymentHistory: paymentHistoryReducer,
    bookings: bookingReducer,
    notifications: notificationReducer,

  
  },
});
